import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";
import StoreContext from "contexts/StoreContext";

import { useTranslation } from "react-i18next";

const TableRegionSelect = ({ title, defaultValue = null, handler }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectRegion") : title;
  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const { storeId, setStoreId } = useContext(StoreContext);

  const handleChange = (e) => {
    setSelectedRegion(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getRegions = async () => {
    try {
      const response = await apiService.get(`api/v1/table-regions/store/${storeId}`);
      const activeRegions = response.filter((el) => !el.deleted);
      const availableRegions = activeRegions.map((el) => {
        return {
          value: el.id,
          label: el.name,
        };
      });
      setRegions(availableRegions);
      setNewValue(null);
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedRegion = regions.find((el) => el.value === defaultValue);
    if (selectedRegion) setSelectedRegion(selectedRegion);
  };

  useEffect(() => {
    if (!storeId) return;
    getRegions();
  }, [storeId]);

  useEffect(() => {
    setNewValue();
  }, [defaultValue]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          styles={customStyles}
          isClearable={true}
          className="primary"
          name="tableRegionSelect"
          onChange={handleChange}
          value={selectedRegion}
          options={regions}
          noOptionsMessage={() => t("messages.noRegionsAreAvailable")}
          placeholder={title}
        />
      </Form.Group>
    </>
  );
};

export default TableRegionSelect;
